import { __decorate, __metadata } from "tslib";
import { dispatchEvent } from '@1inch-community/core/lit-utils';
import { chainList } from '@1inch-community/sdk/chain';
import '@1inch-community/ui-components/button';
import '@1inch-community/ui-components/card';
import '@1inch-community/ui-components/scroll';
import { html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { map as LitMap } from 'lit/directives/map.js';
import '../chain-selector-list-item';
import { chainSelectorListStyle } from './chain-selector-list.style';
let ChainSelectorListElement = class ChainSelectorListElement extends LitElement {
    constructor() {
        super(...arguments);
        this.selectedChainViewList = [];
    }
    static { this.tagName = 'inch-chain-selector-list'; }
    static { this.styles = [chainSelectorListStyle]; }
    render() {
        const text = this.selectedChainViewList.length === chainList.length ? 'Deselect All' : 'Select All';
        return html `
      <inch-card overlayView>
        <inch-card-header separator mini>
          <span slot="left-container" class="title">Networks</span>
          <inch-button
            slot="right-container"
            size="xl"
            type="link"
            @click="${this.onSelectAllClick}"
          >
            <inch-text-animate text="${text}"></inch-text-animate>
          </inch-button>
        </inch-card-header>
        ${this.getList()}
      </inch-card>
    `;
    }
    getList() {
        return html `
      <inch-scroll-view-consumer>
        ${LitMap(chainList, (info) => html `
            <inch-chain-selector-list-item
              .info="${info}"
              .isActiveChain="${this.selectedChainViewList.includes(info)}"
              @chainItemClick="${(event) => this.onChainItemClick(event.detail.value)}"
            ></inch-chain-selector-list-item>
          `)}
      </inch-scroll-view-consumer>
    `;
        // return chainList.map(
        //   (info) => html`
        //     <inch-chain-selector-list-item
        //       .info="${info}"
        //       .isActiveChain="${this.selectedChainViewList.includes(info)}"
        //       @chainItemClick="${(event: CustomEvent) =>
        //         this.onChainItemClick(event.detail.value as ChainViewFull)}"
        //     ></inch-chain-selector-list-item>
        //   `
        // )
    }
    resetSelectedChainViewList() {
        this.selectedChainViewList = [chainList[0]];
    }
    onSelectAllClick() {
        if (this.selectedChainViewList.length === chainList.length) {
            this.resetSelectedChainViewList();
        }
        else {
            this.selectedChainViewList = chainList;
        }
        dispatchEvent(this, 'changeSelectedChainViewList', this.selectedChainViewList);
    }
    onChainItemClick(chainInfo) {
        if (this.selectedChainViewList.includes(chainInfo)) {
            this.selectedChainViewList = this.selectedChainViewList.filter((item) => item !== chainInfo);
        }
        else {
            this.selectedChainViewList = [...this.selectedChainViewList, chainInfo];
        }
        if (this.selectedChainViewList.length === 0) {
            this.resetSelectedChainViewList();
        }
        dispatchEvent(this, 'changeSelectedChainViewList', this.selectedChainViewList);
    }
};
__decorate([
    property({ type: Array, attribute: false }),
    __metadata("design:type", Array)
], ChainSelectorListElement.prototype, "selectedChainViewList", void 0);
ChainSelectorListElement = __decorate([
    customElement(ChainSelectorListElement.tagName)
], ChainSelectorListElement);
export { ChainSelectorListElement };
//# sourceMappingURL=chain-selector-list.element.js.map